export default __webpack_public_path__ + "static/media/GR6 2A-2B-2C-2EC.9ee5f4e9.jpg";